import * as z from "zod/v4";
import { OperatorSchema } from "./operator.js";

const PropertyFilterSchema_ = z.object({
  prop: z.string(),
  operator: OperatorSchema,
  value: z.array(z.string()),
});
export const PropertyFilterSchema: z.ZodType<PropertyFilter> =
  PropertyFilterSchema_;
export interface PropertyFilter extends z.infer<typeof PropertyFilterSchema_> {}
